import 'antd/lib/typography/style';

export * from 'antd/lib/typography';
export { default as Typography } from 'antd/lib/typography';
